import { Vector3 } from 'three';
import { WxRectangle } from './wx-rectangle';
import { WxTextVO } from '@article/model/vo/wx-article.vo';
import { CommonConstants } from '@3d-scene/constants/common-constants';

export class WxText extends WxRectangle {
  public textId: number;
  public alignmentHorizontal: number;
  public alignmentVertical: number;
  public charsHorizontal: number;
  public charsVertical: number;
  public fontBold: boolean;
  public fontItalic: boolean;
  public fontName: string;
  public fontSize: number;
  public fontStrikeout: boolean;
  public fontUnderline: boolean;
  public linesHorizontal: number;
  public linesVertical: number;
  public text: string;

  public constructor(element: WxTextVO) {
    super(element);
    this.textId = element.textId;
    this.alignmentHorizontal = element.alignmentHorizontal;
    this.alignmentVertical = element.alignmentVertical;
    this.charsHorizontal = element.charsHorizontal;
    this.charsVertical = element.charsVertical;
    this.fontBold = element.fontBold;
    this.fontItalic = element.fontItalic;
    this.fontName = element.fontName;
    this.fontSize = element.fontSize;
    this.fontStrikeout = element.fontStrikeout;
    this.fontUnderline = element.fontUnderline;
    this.linesHorizontal = element.linesHorizontal;
    this.linesVertical = element.linesVertical;
    this.text = element.description;
    this.closed = true;
    this.length = element.length > 0 ? element.length * CommonConstants.COMMON_SCALE : 15;
    this.width = element.width > 0 ? element.width * CommonConstants.COMMON_SCALE : 15;
  }

  public getPoints(isConnection: boolean = false): Vector3[] {
    return super.getPoints(isConnection);
  }
}
